import { RouteIdViewModel } from './route-id-viewmodel';

export class LinegraphSettings {
    public routeId: string;
    public date: Date;
    public mode: string;
    public modeLabel: string;
    public perspective: string;
    public perspectiveLabel: string;
    public yValue: number;
    public selectedDates: Date[];
    public selectedRouteIds: RouteIdViewModel[];
    public interval: number;
    public compareRandomRoute: RouteIdViewModel;
    public compareRandomDates: Date[];

    constructor();
    constructor(routeId: string, date: Date, mode: string, modeLabel: string, perspective: string, perspectiveLabel: string,
        yValue: number, selectedDates: Date[], selectedRouteIDs: RouteIdViewModel[], interval: number,
        compareRandomRoute: RouteIdViewModel, compareRandomDate: Date[]);
    constructor(routeId?: string, date?: Date, mode?: string, modeLabel?: string, perspective?: string, perspectiveLabel?: string,
        yValue?: number, selectedDates?: Date[], selectedRouteIds?: RouteIdViewModel[], interval?: number,
        compareRandomRoute?: RouteIdViewModel, compareRandomDates?: Date[]) {
        if (routeId) {
            this.routeId = routeId;
            this.mode = mode;
            this.date = date;
            this.perspective = perspective;
            this.yValue = yValue;
            this.modeLabel = modeLabel;
            this.perspectiveLabel = perspectiveLabel;
            this.selectedDates = selectedDates;
            this.selectedRouteIds = selectedRouteIds;
            this.interval = interval;
            this.compareRandomRoute = compareRandomRoute;
            this.compareRandomDates = compareRandomDates;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/route-detail/viewModels/lineGraph-settings-viewmodel.ts